/**
 * Abstract base class for sync storage providers.
 * Concrete implementations: GoogleDriveProvider, OneDriveProvider.
 *
 * Contract:
 *   signIn()              — authenticate; must store token internally
 *   signOut()             — revoke/clear token
 *   uploadData(name,data) — upload JSON-serialisable object as `name`
 *   downloadData(name)    — download and return parsed object, or null if absent
 *
 * Provider-specific extensions (not part of the core contract):
 *   GoogleDriveProvider: uploadBlob(), fetchSheetValues()
 *   OneDriveProvider:    syncBundle()
 */
export class SyncProvider {
  /** Shared file/folder names — providers reference these so names stay in sync */
  static readonly FOLDER_NAME = 'PunchLog';
  static readonly MANIFEST_NAME = 'punchlog-manifest.json';
  async signIn() {
    throw new Error(`${this.constructor.name}.signIn() not implemented`);
  }
  async signOut() {
    throw new Error(`${this.constructor.name}.signOut() not implemented`);
  }
  async uploadData(_name, _data) {
    throw new Error(`${this.constructor.name}.uploadData() not implemented`);
  }
  async downloadData(_name) {
    throw new Error(`${this.constructor.name}.downloadData() not implemented`);
  }

  /**
   * Last-Write-Wins manifest merge — shared by all providers.
   * @param {object|null} local
   * @param {object|null} remote
   */
  static resolveManifest(local, remote) {
    if (!local) return remote;
    if (!remote) return local;
    return new Date(local.updatedAt) >= new Date(remote.updatedAt) ? local : remote;
  }
}
